import React from 'react'

interface WaveIconProps {
	className: string
}

const WaveIcon: React.FC<WaveIconProps> = ({ className }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="280"
		height="100"
		fill="none"
		viewBox="0 0 280 100"
		className={className}
	>
		<g opacity="0.7">
			<path
				fill="url(#paint0_linear_9_553)"
				d="M19.5 33.698c-29 4.5-32.5 33-32.5 33v92h282s55.001-157.123 0-144.5c-15.417 3.538-19.71 20.44-35.5 19.5-19.028-1.133-16.564-31.313-35.5-33.5-26-3.003-23.334 29.224-43.5 28-12.729-.774-16.777-13.142-29.5-14-22.059-1.488-14 33-46 33-23.827 0-35.955-17.154-59.5-13.5z"
			/>
			<g
				stroke="#fff"
				strokeOpacity="0.25"
				strokeWidth="2"
				d="M19.5 34.698c-28 3-32.5 33-32.5 33v92h282s55.001-157.123 0-144.5c-15.417 3.538-19.71 20.44-35.5 19.5-19.028-1.133-16.564-31.313-35.5-33.5-26-3.003-23.334 29.224-43.5 28-12.729-.774-16.777-13.142-29.5-14-22.059-1.488-14 33-46 33-23.827 0-35.809-16.039-59.5-13.5z"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_9_553"
				x1="140.222"
				x2="140.222"
				y1="0"
				y2="158.698"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#fff" stopOpacity="0.4" />
				<stop offset="1" stopColor="#fff" stopOpacity="0" />
			</linearGradient>
		</defs>
	</svg>
)

export default WaveIcon
